import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getOrder } from "../repositories/cart.repository";
import { useOrderStore } from "../store/useOrderStore";

export const useOrder = (customerId: string | undefined) => {
  const setActiveOrderId = useOrderStore((s) => s.setActiveOrderId);

  const {
    data: order,
    isLoading,
    error,
    isSuccess,
  } = useQuery({
    queryKey: ["order", customerId],
    queryFn: () => getOrder(customerId!), // safe because enabled guards it
    enabled: !!customerId,
  });

  useEffect(() => {
    if (isSuccess && order?.orderId) {
      setActiveOrderId(order.orderId);
    }
  }, [isSuccess, order?.orderId, setActiveOrderId]);

  return { order, isLoading, error };
};
